export function initNewsLoadMore() {
   const btn = document.querySelector('.js-news-load-more');
   if (!btn) return;

   const grid   = document.querySelector('.news-grid');
   const loader = document.createElement('img');
   loader.src   = `${settings.home}/src/img/loader.svg`;
   loader.className = 'news-more__loader';
   btn.appendChild(loader);

   btn.addEventListener('click', async () => {
      btn.classList.add('is-loading');

      const body = new FormData();
      body.append('action', 'ajax_instagram_more');
      body.append('cursor', btn.dataset.cursor);

      try {
         const res  = await fetch(settings.ajaxurl, { method: 'POST', body });
         const json = await res.json();

         json.items.forEach((item) => {
            const img  = item.media_type === 'VIDEO' ? (item.thumbnail_url || item.media_url) : item.media_url;
            const card = document.createElement('a');
            card.href  = item.permalink || '#';
            card.className = 'news-card';
            card.target = '_blank';
            card.rel    = 'noopener';
            const date    = item.timestamp ? new Date(item.timestamp).toLocaleDateString('de-DE') : '';
            const caption = item.caption || '';
            card.innerHTML = `
               <div class="news-card__bg" style="background-image: url('${img}')"></div>
               <div class="news-card__overlay"></div>
               ${item.media_type === 'VIDEO' ? '<span class="news-card__type">▶</span>' : ''}
               <div class="news-card__info">
                  ${date    ? `<span class="news-card__date">${date}</span>` : ''}
                  ${caption ? `<p class="news-card__caption">${caption}</p>` : ''}
               </div>
            `;
            grid.appendChild(card);
         });

         if (json.has_more && json.cursor) {
            btn.dataset.cursor = json.cursor;
            btn.classList.remove('is-loading');
         } else {
            btn.closest('.news-more').remove();
         }
      } catch (e) {
         console.error(e);
         btn.classList.remove('is-loading');
      }
   });
}
